import { render, staticRenderFns } from "./ItemDetailPart.vue?vue&type=template&id=cbcb50f6&scoped=true"
import script from "./ItemDetailPart.vue?vue&type=script&lang=js"
export * from "./ItemDetailPart.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailPart.vue?vue&type=style&index=0&id=cbcb50f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcb50f6",
  null
  
)

export default component.exports